import { render, staticRenderFns } from "./PublishEventsByPeriodDialog.vue?vue&type=template&id=d458aabc&scoped=true"
import script from "./PublishEventsByPeriodDialog.vue?vue&type=script&lang=js"
export * from "./PublishEventsByPeriodDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d458aabc",
  null
  
)

export default component.exports